import {UserOrGroupModel} from './UserOrGroup.model';

export class RoleModel {
    public id: number;
    public theRole: string;
    public usersOrGroups: Array<UserOrGroupModel>;
    public powerBIObjectId: number;
    public modifiedBy: number;
    public modifiedOn: Date;

    public modifiedByUserOrGroup: UserOrGroupModel;

    constructor() {
        this.usersOrGroups = new Array<UserOrGroupModel>();
    }
}
